'use client';

import { usePathname, useRouter } from '../../i18n/i18n-navigation';

export const useLanguageSwitcher = () => {
  const router = useRouter();
  const pathname = usePathname();

  // todo return search parameters after language switch event listener will be introduced
  // const searchParameters = useSearchParams();

  // const parameters = new URLSearchParams(searchParameters);
  // const newPath = parameters.toString() ? `${pathname}?${parameters.toString()}` : pathname;

  const onLanguageChange = (locale: string) => {
    // router.replace(newPath, { locale });
    router.replace(pathname, { locale });
    router.refresh();
  };

  return { onLanguageChange };
};
